import { Injectable } from '@angular/core';

import { ServiceProvider } from '../../../service/provider.interface';

@Injectable()
export class MaterialProvider extends ServiceProvider {
  constructor() {
    super();
  }
}
